// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Api from './api'
import router from './router'
import 'babel-polyfill'
/* 引入公共样式 */
import '../static/style/global.css'
import '../static/style/reset.css'
/* 按需引入mint UI */
// import {Button, Field, Indicator, MessageBox, Popup, Swipe, SwipeItem} from 'mint-ui'
// import 'mint-ui/lib/style.css'
import { Toast, Loading, Field, Button, Popup, PasswordInput, NumberKeyboard, Divider } from 'vant';
import 'vant/lib/index.css';
// import VConsole from 'vconsole'
// let vConsole = new VConsole()
Vue.use(Loading);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Divider);
// Vue.component(Swipe.name, Swipe)
// Vue.component(SwipeItem.name, SwipeItem)
Vue.config.productionTip = false
Vue.prototype.$toast = Toast
// Vue.prototype.$indicator = Indicator
// Vue.prototype.$msg = MessageBox
// Vue.component(Button.name, Button)
// Vue.component(Field.name, Field)
// Vue.component(Popup.name, Popup)
/* eslint-disable no-new */
Vue.use(Api)
Api.$router = router
new Vue({
  el: '#app',
  router,
  created: function () {
    
  },
  components: {App},
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js